import { SetSymbolEffects } from "slotworks/commands/symbols/set-symbol-effects";
import Components from "slotworks/components/components";

export function SetAllSymbolEffects(tint: number, filters: Array<PIXI.Filter<any>>, behaviourNames: string[]) {
    const symbols = Components.matrix.getAllSymbols();
    SetSymbolEffects(symbols, tint, filters, behaviourNames);
}
